module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-2": "",
      "pb-2": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "readonly": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.image.companyId),
      callback: function($$v) {
        _vm.$set(_vm.image, "companyId", $$v)
      },
      expression: "image.companyId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.imageName,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingImageName)); }]
    },
    model: {
      value: (_vm.image.name),
      callback: function($$v) {
        _vm.$set(_vm.image, "name", $$v)
      },
      expression: "image.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.labels,
      "label": _vm.$lang.actions.selectLabel,
      "required": "",
      "loading": _vm.lablesLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingImageLabel)); }]
    },
    model: {
      value: (_vm.image.label),
      callback: function($$v) {
        _vm.$set(_vm.image, "label", $$v)
      },
      expression: "image.label"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    ref: "fileTextField",
    staticClass: "min-w",
    attrs: {
      "prepend-icon": "attach_file",
      "single-line": "",
      "hide-details": "",
      "label": "choose_file",
      "required": ""
    },
    on: {
      "click": function($event) {
        return _vm.startInput('imageInput')
      }
    },
    model: {
      value: (_vm.filename),
      callback: function($$v) {
        _vm.filename = $$v
      },
      expression: "filename"
    }
  }), _vm._v(" "), _c('input', {
    ref: "imageInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange('imageInput', $event)
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0 mt-4",
    attrs: {
      "disabled": _vm.previewValidation(),
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.preview()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.preview) + "\n          ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-3 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.publiclyAvailable,
      "hide-details": ""
    },
    model: {
      value: (_vm.image.publiclyAvailable),
      callback: function($$v) {
        _vm.$set(_vm.image, "publiclyAvailable", $$v)
      },
      expression: "image.publiclyAvailable"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'images'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('div', [(_vm.isEdit) ? _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.toggleActivate()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.image.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.previewModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "800"
    },
    model: {
      value: (_vm.previewModal),
      callback: function($$v) {
        _vm.previewModal = $$v
      },
      expression: "previewModal"
    }
  }, [_c('preview', {
    attrs: {
      "data": _vm.previewData,
      "image": _vm.image
    },
    on: {
      "close": function($event) {
        _vm.previewModal = false
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-2": ""
    }
  }, [(_vm.image.base64Image !== '') ? _c('v-card', {
    staticClass: "pa-4"
  }, [_c('v-img', {
    staticStyle: {
      "width": "50% !important",
      "height": "50% !important"
    },
    attrs: {
      "contain": "",
      "src": _vm.image.base64Image
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84964fc2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/images/ImageDetails.vue
// module id = 423
// module chunks = 35